import {
  CheckoutOrderSummaryItemMolecule,
  CheckoutOrderTrialSummaryItemMolecule,
} from '../../molecules/';
import React from 'react';
import { formatCurrency } from '../../../utils';
import { TrustpilotWidgetOrganism } from '../trustpilot-widget';
import { checkoutOrderLabels } from '../../../enums';
import { usePatientOrderSummaryEffect } from './patient-order-summary.effect';
import useMounted from '../../../effects/common/mounted.effect';

export const PatientOrderSummaryOrganism = () => {
  const mounted = useMounted();

  const {
    cartState: { cart, countProductVariants, includesTrial },
    clearCartProductVariant,
    clearCartTrial,
  } = usePatientOrderSummaryEffect();

  const totalBeforeDiscount =
    (cart?.subtotalPrice || 0) + (cart?.shippingOption?.shippingPrice || 0);

  const totalDiscount =
    cart?.discountDeduction || cart?.creditDeduction
      ? (cart?.discountDeduction || 0) + (cart?.creditDeduction || 0)
      : 0;

  return (
    <>
      <div
        data-cy="checkout-order-summary-organism"
        className="bg-waldo-light-blue p-5 mx-auto lg:mx-0 rounded-lg mb-3 mt-5 lg:mt-0"
      >
        <h2 className="mb-4 text-base font-waldo-sans font-semibold md:text-2xl">
          Order summary
        </h2>
        <div className="py-2.5 bg-waldo-lighter-blue rounded-lg">
          {includesTrial && (
            <>
              {cart?.trials.map((cartTrial, index) => (
                <CheckoutOrderTrialSummaryItemMolecule
                  key={index}
                  cartTrials={cartTrial}
                  clearCartTrial={clearCartTrial}
                />
              ))}
            </>
          )}

          {countProductVariants > 0 && (
            <>
              {cart?.productVariants.map((variant, index) => (
                <CheckoutOrderSummaryItemMolecule
                  key={index}
                  cartProductVariant={variant}
                  clearCartProductVariant={clearCartProductVariant}
                />
              ))}
            </>
          )}

          {countProductVariants <= 0 && !includesTrial && (
            <p className="text-base font-waldo-sans md:text-xl">
              Your basket is currently empty
            </p>
          )}
        </div>
        {cart ? (
          <>
            <div className="pricing border-b border-border-blue my-4 py-5 pricing">
              <div className="flex justify-between my-2">
                <p className="text-base font-waldo-sans md:text-xl">
                  {checkoutOrderLabels.orderSubtotal}
                </p>
                <p className="text-base font-waldo-sans md:text-xl">
                  {formatCurrency(cart.subtotalPrice || 0, 2, 2)}
                </p>
              </div>
              <div className="flex justify-between my-2">
                <p className="text-base font-waldo-sans md:text-xl">
                  {checkoutOrderLabels.orderShipping}
                </p>
                <p className="text-base font-waldo-sans md:text-xl">
                  {formatCurrency(
                    cart.shippingOption?.shippingPrice || 0,
                    2,
                    2
                  )}
                </p>
              </div>
              <div className="flex justify-between my-2">
                <p className="text-base font-waldo-sans md:text-xl">
                  {checkoutOrderLabels.orderTotalTax}
                </p>
                <p className="text-base font-waldo-sans md:text-xl">
                  {formatCurrency(totalBeforeDiscount || 0, 2, 2)}
                </p>
              </div>
              {totalDiscount > 0 && (
                <div className="flex justify-between my-2">
                  <p className="text-base font-waldo-sans md:text-xl">
                    {checkoutOrderLabels.orderDiscount}
                  </p>
                  <p className="text-base font-waldo-sans md:text-xl">
                    - {formatCurrency(totalDiscount, 2, 2)}
                  </p>
                </div>
              )}
              <div className="flex justify-between my-0.5">
                <p className="text-base font-waldo-sans md:text-xl">
                  {checkoutOrderLabels.orderEstTax}
                </p>
                <p className="text-base font-waldo-sans md:text-xl">
                  {formatCurrency(cart.taxPrice || 0, 2, 2)}
                </p>
              </div>
            </div>
            <div className="total flex justify-between font-waldo-header">
              <p className="font-waldo-sans font-semibold text-xl md:text-2xl">
                {checkoutOrderLabels.orderPaymentDue}
              </p>
              <div className={'text-right'}>
                {cart.grandTotalPrice < cart.subtotalPrice && (
                  <span className="text-waldo-blue font-semibold text-xl md:text-2xl line-through block inline-block px-1">
                    <p className="font-waldo-sans text-border-blue font-semibold text-xl md:text-2xl">
                      {formatCurrency(
                        (totalBeforeDiscount || 0) + (cart.taxPrice || 0),
                        2,
                        2
                      )}
                    </p>
                  </span>
                )}
                <p className="font-waldo-sans font-semibold text-xl md:text-2xl">
                  {formatCurrency(cart.grandTotalPrice || 0, 2, 2)}
                </p>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      {mounted && (
        <div className="w-full bg-white pt-1 pb-2 mt-4">
          <TrustpilotWidgetOrganism
            templateId="5419b6ffb0d04a076446a9af"
            styleHeight="42px"
            theme="light"
          />
        </div>
      )}
    </>
  );
};
